import React from 'react'
import MainSection from '../components/ContactUs/MainSection'
import ContactUs from '../components/ContactUs/ContactUs'

const ContactUsPage = () => {
  return (
    <>
        <MainSection/>
        <ContactUs/>
    </>
  )
}

export default ContactUsPage